import { CategoryClick, CategoryImpression, SearchClick, SearchImpression } from "@/types"
import logger from "@/core/logger"
import settings from "@/core/settings"
import { AnalyticsType, Endpoint } from "./types"
import visits from "@/core/visit"
import context from "@/core/context"
import { logAnalyticsError, sendOrEnqueue } from "@/core/analytics"

type Mapping = {
  "search:impression": SearchImpression
  "search:click": SearchClick
  "category:impression": CategoryImpression
  "category:click": CategoryClick
}

export async function reportAnalytics<T extends AnalyticsType, E extends Endpoint>(
  type: T,
  endpoint: E,
  data: Mapping[`${T}:${E}`]
) {
  if (visits.isDoNotTrack()) {
    logger.info("Skipping analytics event, do not track mode is enabled")
    return
  }
  let start = Date.now()
  try {
    if (context.mode.isBot()) {
      return
    }
    const url = `${settings.server}/analytics/${type}/${endpoint}`
    start = Date.now()
    await sendOrEnqueue(url, data, { delayed: endpoint === "click" })
  } catch (e) {
    const duration = Date.now() - start
    logAnalyticsError(`Failed to send ${type} ${endpoint} analytics`, e, duration)
  }
}
